<template>
<div class="appointment-form py-10 px-6 md:p-16 bg-primary-dark text-secondary text-left  text-color">
  <h6 class="mb-4 md:mb-10 text-xl md:text-2xl tracking-0.15px">
    {{ content.title }}
  </h6>
  <VeeForm @submit="handleSubmit"  v-slot="{ meta }">
    <div v-dompurify-html="content.description" class="richtext" for="zipcode" />
    <VeeField
      id="zipcode"
      name="zipcode"
      type="text"
      maxlength="10"
      class="
        input
        mt-6
        md:mt-10
        mb-2
        p-4
        rounded-t
        text-base
        tracking-0.15px
        text-black-high-emphasis
        border-2
        border-transparent
        outline-none
      "
      :class="!meta.valid && meta.touched  ? 'border-error-base' : 'focus:border-black-darkest'"
      :placeholder="content.inputPlaceholder"
      :rules="{ regex: /(^\d{5}$)|(^\d{5}-\d{4}$)/, required: true}"
      :validateOnInput="meta.touched"
    />
    <ErrorMessage name="zipcode" as="p" class="text-sm" data-testid="zipcode-invalid-message">
      {{ content.invalidZipCodeMessage }}
    </ErrorMessage>
    <KButton theme="secondary" type="submit" class="mt-2 bg-color" :aria-disabled="!meta.valid">
      {{ content.buttonText }}
    </KButton>
  </VeeForm>
</div>
</template>

<script lang="ts">
import KButton from '@/components/atoms/Button/index.vue';
import { defineComponent } from 'vue'
import { Form, Field, ErrorMessage, defineRule } from 'vee-validate'
import { required, regex } from '@vee-validate/rules'
import { AppointmentForm } from '@/model'
import { trackEvent } from '@/utils/analytics'
import { addAdobeDataLayerEventProviderSearch } from '@/utils/adobe-analytics-data-layer'

defineRule('required', required)
defineRule('regex', regex)
const ZIPCODE_VARIABLE = '$ZIP_CODE'

export default defineComponent({
  components: {
    KButton,
    VeeForm: Form,
    VeeField: Field,
    ErrorMessage
  },
  props: {
    content: {
      type: AppointmentForm,
      required: true,
      validator: (value: AppointmentForm) => value instanceof AppointmentForm
    }
  },
  setup (props) {
    function handleSubmit ({ zipcode }: { zipcode: string }) {
      addAdobeDataLayerEventProviderSearch()
      const url = props.content.findProviderUrl.replace(ZIPCODE_VARIABLE, zipcode)
      window.location.href = url
    }

    return {
      handleSubmit
    }
  }
})
</script>

<style scoped>
.text-color{
    color: white;
}
.bg-color{
 @apply  text-primary bg-secondary
}
.border-error-base{
  border-color: #E53935;
}
.input {
  height: 52px;
  width: 295px;
  max-width: 100%;
  background-color: #FFFFF;
  -moz-appearance: textfield;
}

@screen md {
  .input {
    width: 350px;
  }
}

::placeholder {
  color: theme('colors.black.inactive');
  opacity: 1;
}

::-ms-input-placeholder {
  color: theme('colors.black.inactive');
  opacity: 1;
}
</style>
